import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/product/product-type-pools?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`///${id}`, { params });
}

export async function create(body) {
  return request(`//`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`///${id}`, {
    method: 'POST',
    body,
  });
}
export async function approve(id, body) {
  return request(`/product/product-type-pool/commit/${id}`, {
    method: 'POST',
    body,
  });
}